export const selectCourses = (state) => state.courses.courses
export const selectNoCoursesFound = (state) => state.courses.noCoursesFound
